<template>
  <AppTextField
    :value="value"
    :type="type"
    :validation-state="validationState"
    :placeholder="placeholder"
    :disabled="disabled"
    :readonly="readonly"
    :formatter="formatter"
    :inputmode="inputmode"
    @focus="onFocus"
    @input="onInput"
    @blur="onBlur"
    maxlength="2"
    class="time-input text-center"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import AppTextField from "@/components/atoms/input/AppTextField.vue";

type ValidationStateType = {
  validated: boolean;
  valid: boolean | undefined;
};

@Component({
  components: {
    AppTextField
  }
})
export default class TextFieldGroup extends Vue {
  @Prop({
    validator: prop =>
      typeof prop === "string" || typeof prop === "number" || prop === null,
    required: true,
    default: ""
  })
  value!: string | number | null;

  @Prop({
    type: String,
    default: ""
  })
  label!: string;

  @Prop({
    type: String,
    default: ""
  })
  appLabelText!: string;

  @Prop({
    type: String,
    default: ""
  })
  placeholder!: string;

  @Prop({
    type: String,
    default: "text"
  })
  type!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  readonly!: boolean;

  @Prop({
    type: Object,
    default: {}
  })
  validationState!: ValidationStateType;

  @Prop({
    type: String,
    default: ""
  })
  description!: string;

  @Prop({
    type: Number,
    default: 0
  })
  max!: number;

  @Prop({
    type: String,
    default: null
  })
  inputmode!: string | null;

  onFocus() {
    this.$emit("focus");
  }

  onInput(v: string) {
    this.$emit("input", v);
  }

  onBlur(v: Event) {
    if (!(v.target instanceof HTMLInputElement)) {
      return;
    }
    const value = ("00" + v.target.value).slice(-2);
    this.$emit("blur", value);
  }

  formatter(v: string) {
    let value;
    value = v.replace(/\D/g, "");
    if (this.max < parseInt(value)) {
      value = this.max;
    }
    return value;
  }
}
</script>

<style lang="scss" scoped>
.time-input {
  padding-right: 8px;
  font-size: 18px;
  letter-spacing: 1px;

  &.form-control.is-invalid,
  &.form-control.is-valid {
    padding-right: 8px !important;
    background-image: none;

    &:focus {
      border-color: $gray-04;
      box-shadow: none;
    }
  }

  &.form-control.is-invalid {
    border-color: $red;
  }

  @media screen and (max-width: 470px) {
    font-size: 16px;
  }
  @media screen and (max-width: 375px) {
    font-size: 14px;
  }
  @media screen and (max-width: 280px) {
    font-size: 12px;
  }
}
</style>
